<template>
  <div class="app" v-title data-title="富林活动 - 富林资讯-广富林文化遗址公园">
    <component :is="headerComponent" :activeIndex="3" />
    <div class="yj-banner rel">
      <img src="@/assets/images/zx-banner.png" class="db wp100" alt="banner">
      <div class="crumbs-nav df align_center justify_end fa_wh box-border">
        <router-link to="/" class="f16 fw">首页</router-link>
        <img src="@/assets/images/arrow-wh-05.png" class="db w20 ml5 mr5" alt="">
        <router-link to="/zixun" class="f16 fw">资讯动态</router-link>
      </div>
      <div class="yj-banner-tit df align_center flex_column justify_center ts fw">
        <div class="f50 ls1 b">富林活动</div>
        <div class="f16 ls3">Fu Lin Huo Dong</div>
      </div>
      <div class="yj-nav wp100">
        <div class="yj-nav-item df align_center justify_center">
          <div class="yj-nav-box active">
            <router-link to="/zixun" class="yj-nav-link db f24">全部</router-link>
          </div>
          <div class="yj-nav-box ">
            <router-link to="/zixun" class="yj-nav-link db f24">即将开始</router-link>
          </div>
          <div class="yj-nav-box ">
            <router-link to="/zixun" class="yj-nav-link db f24">进行中</router-link>
          </div>
          <div class="yj-nav-box">
            <router-link to="/zixun" class="yj-nav-link db f24">已结束</router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="wz-gonglue mt30 pb100 w1200 auto">
      <div class="df justify_between">
        <div class="w1000">
          <div class="wz-gonglue-item  df flex_wrap" style="margin-left: -10px; margin-right: -10px;">
            <div class="wz-zixun-box wp50 mb30" v-for="(index,item) in 10" :key="index">
              <router-link to="/zixun-view" class="ml10 mr10 db bgwh wz-zixun-link">
                <div class="wz-zixun-pic rel">
                  <img src="@/assets/images/index-p1.png" class="db wp100" alt="" />
                  <div class="wz-zixun-state abs t0 r0">
                    <div class="fw tdn f16">进行中</div>
                  </div>
                </div>
                <div class="wz-zixun-text pd15">
                  <div class="f18 b">上海松江广富林希尔顿酒店</div>
                  <div class="mt10">水岸院居，感受诗意之旅</div>
                  <div>活动日期：2024-10-23/2025-12-31</div>
                </div>
              </router-link>
            </div>
          </div>
          <div class="pages df align_center justify_center pt50 pb50">
            <div class="pages-btn df align_center justify_center">
              <img src="@/assets/images/pages-lt.png" class="db" alt="" />
            </div>
            <div class="pages-item df align_center justify_center">
              <router-link to="/" class="pages-box df align_center justify_center">1</router-link>
              <router-link to="/" class="pages-box df align_center justify_center">2</router-link>
              <router-link to="/" class="pages-box df align_center justify_center">3</router-link>
              <router-link to="/" class="pages-box df align_center justify_center">4</router-link>
              <router-link to="/" class="pages-box df align_center justify_center">5</router-link>
              <router-link to="/" class="pages-box df align_center justify_center">6</router-link>
              <router-link to="/" class="pages-box df align_center justify_center">7</router-link>
              <router-link to="/" class="pages-box df align_center justify_center">8</router-link>
            </div>
            <div class="pages-btn df align_center justify_center">
              <img src="@/assets/images/pages-rt.png" class="db" alt="" />
            </div>
          </div>
        </div>

        <div class="wz-gonglue-cate">
          <div class=" bgwh box-border pd20">
            <div class="f20 b tc">时间筛选</div>
            <router-link to="/" class="df align_center justify_center f16 wz-gonglue-cate-box">
              <div class="foy">&lt;&lt;&nbsp;</div>
              <div class="foy">全部</div>
              <div class="foy">&nbsp;&gt;&gt;</div>
            </router-link>
            <router-link to="/" class="df align_center justify_center f16 wz-gonglue-cate-box">
              <div>近一月</div>
            </router-link>
            <router-link to="/" class="df align_center justify_center f16 wz-gonglue-cate-box">
              <div>2025年</div>
            </router-link>
            <router-link to="/" class="df align_center justify_center f16 wz-gonglue-cate-box">
              <div>2024年</div>
            </router-link>
          </div>
        </div>
      </div>



    </div>
    <component :is="bottomComponent" />
  </div>
</template>

<script>
import Header from '../../components/header.vue'
import Bottom from '../../components/bottom.vue'

export default {
  name: 'app',
  data () {
    return {
      headerComponent: 'Header',
      bottomComponent: 'Bottom',

    }
  },
  components: { Header, Bottom,},
  methods:{

  },

}
</script>



// WEBPACK FOOTER //
// src/views/zixun/index.vue